import styled from 'styled-components';
import { AlliePopover } from '../../../components/Popover';
import { AllieText } from '../../../components/Text';

interface StyledLinkProps {
  ellipsis?: boolean;
  width?: number | string;
  maxWidth?: number | string;
}

export const StyledEllipsedText = styled(AllieText)<StyledLinkProps>`
  ${(props) => (props.ellipsis ? 'display: block !important' : '')};
  ${({ ellipsis, maxWidth }) =>
    ellipsis ? `max-width: ${maxWidth}${isNaN(Number(maxWidth)) ? '' : 'px'}` : ''};
  ${({ ellipsis, width }) =>
    ellipsis ? `width: ${width}${isNaN(Number(width)) ? '' : 'px'}` : ''};
  ${(props) => (props.ellipsis ? 'text-overflow: ellipsis' : '')};
  ${(props) => (props.ellipsis ? 'overflow: hidden' : '')};
  ${(props) => (props.ellipsis ? 'white-space: nowrap' : '')};
`;

export const StyledAlliePopover = styled(AlliePopover)`
  && {
    --width: fit-content;
  }
  && {
    --offset-x: 5px;
  }
  && {
    --offset-y: 40px;
  }
`;
